import { Qonty } from "@components/Qonty";
import { VerticalContainer } from "@shared/designSystem/Containers";
import { Loader } from "@shared/designSystem/Loader";
import { Text } from "@shared/designSystem/Texts";
import designSystemStyles from "@shared/styles/designSystemStyles";

interface QontyLoadingProps {
    text?: string;
    withQonty?: boolean;
    qontyHeight?: string;
    qontyWidth?: string;
    darkMode?: boolean;
    className?: string;
}

export const QontyLoading: React.FC<QontyLoadingProps> = ({
    text,
    withQonty = false,
    qontyHeight = "80px",
    qontyWidth = "80px",
    darkMode,
    className = "QontyLoadingState",
}) => {
    return (
        <VerticalContainer
            className={className}
            height="100%"
            width="100%"
            alignment="center"
            justifyContent="center"
            gap={designSystemStyles.gapSm}
        >
            {withQonty ? (
                <Qonty
                    height={qontyHeight}
                    width={qontyWidth}
                    blackAndWhite={true}
                    opacity={0.4}
                    darkMode={darkMode}
                />
            ) : null}
            {text ? (
                <Text
                    text={`**${text.trim()}**`}
                    alignment="center"
                    color={designSystemStyles.colorTextSecondary}
                    markdown={true}
                />
            ) : null}
            <Loader />
        </VerticalContainer>
    );
};
